<div *ngIf="spinner">
    <ngx-spinner size="medium" type="timer">
      <p style="font-size: 20px; color: white; padding-left:7%;">Loading...</p>
    </ngx-spinner>
  </div>
  
  <div class="container-fluid">
    <div class="card">
      <div class="card-header">
        <div class="d-flex justify-content-between">
          <h4 class="font-weight-bold text-dark">ENROLLED STUDENTS LIST</h4>
        </div>
      </div>
  
      <div *ngIf="!tableshow" class="d-flex justify-content-center">
        <div class="loader"></div>
      </div>
  
      <div class="p-3" *ngIf="tableshow">
        <div class="table-responsive">
          <table class="table table-bordered display" datatable width="100%" cellspacing="0">
            <thead>
              <tr>
                <th>Course Name</th>
                <th>Student Name</th>
                <th>Email</th>
                <th>Mobile No</th>
                <th>Show</th>


              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let course of courses">
                <td>{{course.course_name}}</td>
                <td >{{course.student_name}}</td>
                <td >{{course.student_email}}</td>
                <td>{{course.student_number}}</td>
<td> <a data-toggle="modal" data-target="#myModal" class="btn btn-primary btn-circle btn-sm" (click)="show(course,'show')">
    <i class="fas fa-check"></i>
  </a></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  

 
  <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="modalTitle" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header" style="background-color: #015792;color:white">
          <h5 class="modal-title" id="modalTitle">STUDENT ENROLL DETAILS</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div *ngIf="selectedStudent">
            <div class="container">
                <div class="row">
                  <!-- Column 1 -->
                  <div class="col-md-6">
                    <p><strong>Course Name:</strong> {{ selectedStudent.course_name }}</p>
                    <p><strong>Course Date:</strong> {{ selectedStudent.course_date }}</p>
                    <p><strong>Course Time:</strong> {{ selectedStudent.course_time }}</p>
                  </div>
                  <!-- Column 2 -->
                  <div class="col-md-6">
                    <p><strong>Student Name:</strong> {{ selectedStudent.student_name }}</p>
                    <p><strong>Email:</strong> {{ selectedStudent.student_email }}</p>
                    <p><strong>Mobile No:</strong> {{ selectedStudent.student_number }}</p>
                  </div>
                </div>
              </div>        
             </div>
          <div *ngIf="!selectedStudent">
            <p>No details available.</p>
          </div>
        </div>
        <!-- <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div> -->
      </div>
    </div>
  </div>
  
